define("Cart.Summary.View.Ext", [
  "Cart.Summary.View",
  "SC.Configuration",
  "Profile.Model",
  "underscore",
], function (View, Configuration, ProfileModel, _) {
  "use strict";

  _.extend(View.prototype, {
    getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var self = this;
      var profile = ProfileModel.getInstance();
      var cart = self.model;
      var multiplierMap = Configuration.get("speedmaster.MultiplerMap") || [];
      var totalSavings = 0;
      var totalPoints = 0;
      var bgcolor = "transparent";

      if (cart && cart.get("lines") && cart.get("lines").models) {
        for (var i = 0; i < cart.get("lines").length; i++) {
          var line = cart.get("lines").models[i];
          var item = line.get("item");
          var compareprice = item.get("_comparePriceAgainst");
          var qty = line.get("quantity");
          var amt = line.get("amount");
          var pointMultipler =
            item.get("custitem_pointsmultiplier") || "Single";
          var points = line.get("amount");
          var warrantyId = Configuration.get("sssextendedwarranty.productid");

          var objMultipler = _.find(multiplierMap, function (tisMultiplier) {
            return tisMultiplier.name == pointMultipler;
          });
          if (objMultipler && objMultipler.multiplier) {
            points = points * objMultipler.multiplier;
            bgcolor = objMultipler.bgcolor;
            totalPoints += points;
          }

          if (compareprice && compareprice > 0) {
            compareprice = compareprice * qty;
          }
          if (compareprice > amt && warrantyId != item.get("internalid")) {
            totalSavings += compareprice - amt;
          }
        }
      }

      var priceLevelMap = Configuration.get("speedmaster.PriceLevelMap") || [];
      var pricelevel = profile.get("priceLevel");
      var currentpricelevel = _.find(priceLevelMap, function (tisPriceLevel) {
        return tisPriceLevel.value == pricelevel;
      });
      var is_loged_in =
        (profile.get("isLoggedIn") === "T" && profile.get("isGuest") === "F") ||
        (profile.get("isRecognized") === "T" &&
          profile.get("name") &&
          profile.get("name").length > 0);

      return _.extend(context, {
        totalSavings: totalSavings > 0 ? totalSavings.toFixed(2) : "",
        totalPoints: Math.round(totalPoints),
        bgcolor: bgcolor,
        isLoggedIn: is_loged_in,
        currentpricelevel: currentpricelevel,
      });
    }),
  });
});
